import {commonActions} from '../../actions/commonActions';
import {categorySetList} from '../../actions/productActions';
import {connect} from 'react-redux';
import List from '../../components/product/CategoryList';
import {API_FETCH} from '../../services/FetchService';
import {commonConstants} from "../../constants";



const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));

    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

export const list = (value) => {
    return (dispatch, getState) => {
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('product/category',{params: value}).then(list => {
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
            dispatch(categorySetList(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.product.categoryList,
        common       : state.common,
        initialValues: state.product.categoryTargetItem
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);